import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Import the custom location icon
import Location from '../assets/icons/location.svg';

// Fix Leaflet's default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Define a custom marker icon using the imported SVG
const customIcon = new L.Icon({
  iconUrl: Location, // Path to your custom SVG icon
  iconSize: [32, 32], // Set the size of the icon
  iconAnchor: [16, 32], // Anchor the icon's position to the correct location on the map
  popupAnchor: [0, -32], // Set the popup position
});

const MapComponent = ({ lat, lng }) => {
  const [position, setPosition] = useState([lat || 35.6892, lng || 51.3890]); // Default to Tehran if no lat/lng is passed

  useEffect(() => {
    if (lat && lng) {
      setPosition([lat, lng]); // Update position if lat/lng are passed
    }
  }, [lat, lng]);

  return (
    <MapContainer
      center={position}
      zoom={13}
      style={{ height: '300px', width: '100%' }}
    >
      {/* Use OpenStreetMap with Persian tiles */}
      <TileLayer
        url="https://mt0.google.com/vt/lyrs=m@132&hl=fa&x={x}&y={y}&z={z}"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        minZoom={0}
        maxZoom={22}
      />
      <Marker position={position} icon={customIcon} interactive={false}></Marker>
    </MapContainer>
  );
};

export default MapComponent;
